export default __webpack_public_path__ + "static/media/titulo.ca7bfcf0.png";